<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M4.19456 0.57131C3.91204 0.569597 3.63888 0.672598 3.42783 0.860436C3.21677 1.04827 3.08278 1.30763 3.05171 1.58846C2.92599 2.79988 2.85742 4.62846 2.85742 5.14274C2.85742 8.13703 5.14314 9.71417 8.00028 9.71417C10.8574 9.71417 13.1431 8.13703 13.1431 5.14274C13.1431 4.62846 13.0746 2.85703 12.9488 1.58846C12.9178 1.30763 12.7838 1.04827 12.5727 0.860436C12.3617 0.672598 12.0885 0.569597 11.806 0.57131H4.19456Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.89062 4H13.1097"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 9.71436V15.4286"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.71484 15.4282H10.2863"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
